/**
 * advisorRules.service.ts — Layer 3: File Note Advisor Rules Domain
 */

import { getRequest } from './http.service';
import { URL_ADVISOR_RULES_MENTIONABLE } from './url.service';

export interface AdvisorRuleMentionCandidate {
  id: string;
  ruleText: string;
}

/** This advisor's active file-note rules — global (no templateId) or scoped to one template, for the chat ^rule picker */
export const fetchAdvisorRulesForMentions = (templateId?: string): Promise<AdvisorRuleMentionCandidate[]> =>
  getRequest(URL_ADVISOR_RULES_MENTIONABLE(templateId));
